import "./select.css";
import "../../edit.css";
import dayjs from "dayjs";
import { DatePicker, DatePickerProps } from "antd";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { CalendarSelectProps } from "./select.props";
import { Box } from "../../wrapper";
import { useLanguage } from "../../../../hooks";
import { dateFormat } from "../../../../utils";

dayjs.extend(customParseFormat);

export const CalendarSelect: React.FC<CalendarSelectProps> = (props) => {
  const { t } = useLanguage();

  const onChange: DatePickerProps["onChange"] = (_, dateString) => {
    if (dateString.length === 0 || dateString.length === 10) {
      return props.onChange(dateString as string);
    }
  };

  return (
    <Box
      show={props.show}
      error={props.error}
      isDisabled={props.disabled ?? false}
    >
      <DatePicker
        id={props.id}
        format={dateFormat}
        onChange={onChange}
        value={props.value ? dayjs(props.value, dateFormat) : null}
        className={`edit-box ${props.className}`}
        placeholder={
          props.placeholder ?? t.components.calendar.placeholderDefault
        }
      />
    </Box>
  );
};
